import React from 'react';
import { motion } from 'framer-motion';
import { Shield, LayoutList, Target } from 'lucide-react';
export function Benefits() {
  return <section className="bg-white py-20 lg:py-28" data-id="element-13">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="mx-auto max-w-3xl text-center mb-16" data-id="element-15">
          <h2 className="mb-6 text-3xl text-slate-900 md:text-4xl lg:text-5xl font-display" data-id="element-16">
            UN SISTEMA QUE TE ORDENA
            <br data-id="element-17" />
            <span className="text-emerald-600" data-id="element-18">
              Y TE DA DIRECCIÓN EN SESIÓN
            </span>
          </h2>
          <p className="text-xl font-bold text-slate-700 mb-4" data-id="element-19">
            KIT Psicólogo Deportivo™ | Método Mente y Rendimiento™
          </p>
          <p className="text-lg text-slate-600 mb-6" data-id="element-20">
            Creamos un sistema claro y aplicable para que dejes de improvisar
            frente a deportistas que se bloquean, pierden confianza, se frustran
            después del error o no logran rendir como entrenan.
          </p>
          <p className="text-lg text-slate-600 mb-6" data-id="element-21">
            Este kit te ayuda a transformar problemas de rendimiento en sesiones
            estructuradas, herramientas concretas y un proceso profesional con
            dirección.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3 max-w-6xl mx-auto" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl bg-slate-50 p-8 border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-23">
            <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-emerald-100 text-emerald-600" data-id="element-24">
              <Shield className="h-7 w-7" data-id="element-25" />
            </div>
            <h3 className="mb-4 text-xl font-bold text-slate-900 uppercase" data-id="element-26">
              MÁS SEGURIDAD PROFESIONAL
            </h3>
            <p className="text-slate-600" data-id="element-27">
              Entrás a cada sesión sabiendo qué observar, cómo conducir el
              encuentro y cómo transformar el problema del deportista en un plan
              de trabajo mental.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="rounded-2xl bg-slate-50 p-8 border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-28">
            <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-blue-100 text-blue-600" data-id="element-29">
              <LayoutList className="h-7 w-7" data-id="element-30" />
            </div>
            <h3 className="mb-4 text-xl font-bold text-slate-900 uppercase" data-id="element-31">
              MÁS ORDEN EN CADA PROCESO
            </h3>
            <p className="text-slate-600" data-id="element-32">
              Dejás de depender de "a ver qué trae hoy" y empezás a trabajar con
              evaluación, planificación, intervención y seguimiento.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="rounded-2xl bg-slate-50 p-8 border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-33">
            <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-amber-100 text-amber-600" data-id="element-34">
              <Target className="h-7 w-7" data-id="element-35" />
            </div>
            <h3 className="mb-4 text-xl font-bold text-slate-900 uppercase" data-id="element-36">
              ESTRUCTURA REAL
            </h3>
            <p className="text-slate-600" data-id="element-37">
              Herramientas, plantillas, guiones y protocolos listos para aplicar
              en sesiones individuales, equipos, lesiones, competencia y
              comunicación con cuerpo técnico.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}